import { render, staticRenderFns } from "./classical-observation-detail.vue?vue&type=template&id=392f11c2"
import script from "./classical-observation-detail.vue?vue&type=script&lang=js"
export * from "./classical-observation-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports